export class Roles {
    public static SUPERADMIN: string  = 'SUPERADMIN';
    public static ADMIN: string  = 'ADMIN';
    public static MANAGER: string = 'MANAGER';
    public static OPERATOR: string = 'OPERATOR';
    public static DEMO: string = 'DEMO';
}
